export default __webpack_public_path__ + "static/media/academic-logo.c8e48ae2.svg";